<div class="app__addDocument-card-wrapper pb-0">
  <div class="app__addDocument-card-top">
    <div class="flex flex-col">
      <p class="app__addDocument-card-title">{{ title }}</p>
    </div>

    <div>
      <button class="app__addDocument-addButton" [disabled]="isRemoveEditSaveSharing" (click)="!isRemoveEditSaveSharing && openFormDialog()">
        <p
          class="app__form--attribute--add--btn"
          [ngClass]="{ 'hover:cursor-pointer': !isRemoveEditSaveSharing, 'text-[#C1C2C5] hover:cursor-default': isRemoveEditSaveSharing }"
        >
          <span class="material-icons text-xl">add</span> Update
        </p>
      </button>
    </div>
  </div>

  <div class="app__addDocument-card-bottom pb-0">
    @for ( input of filterList; track $index; let last = $last) { @if( !input?.DoNotShowInTemplate ){

    <div [class]="'app__addDocument-card-bottom-list flex items-center justify-between' + ' ' + (last ? 'border-0' : ' ')">
      <p class="text-sm" [matTooltip]="input?.title">
        {{ input?.title ?? '' }}
      </p>
      <b class="font-semibold text-lg my-[0.5rem]"></b>
      <b [class]="handleStyleClassForAttributeValues(input)">
        @if(!attribute?.getFormValues ){ {{ getAttributeItemValue(input) }}
        } @else { @if(input?.type == 'Dollar Input'){
        {{ attribute?.getFormValues[input.key] | currency : 'USD' : true : '1.2-2' }}
        } @else if(input?.type == 'Numeric Input'){
        {{ attribute?.getFormValues[input.key] | number : '1.2-2' }}
        } @else if(input?.type == 'Percentage' || input?.type == 'Percentage Input'){
        {{ attribute?.getFormValues[input.key] + '%' }}
        } @else{
        {{ attribute?.getFormValues[input.key] ?? '' }}
        } }
      </b>
    </div>
    } }
  </div>
</div>
<br />
